<template>
  <span class="v2026-action-chip" :class="{ 'v2026-action-chip--op': op }"
        :style="validFill ? { color: fill.fg, backgroundColor: fill.bg, borderColor: fill.border } : (color ? { color: color, borderColor: color } : null)"
        @click="$emit('click', $event)">
    <span class="v2026-action-chip-ico" aria-hidden="true"
          :style="{ '-webkit-mask-image': 'url(' + icon + ')', 'mask-image': 'url(' + icon + ')' }"></span>
    <span class="v2026-op-badge" v-if="badge">{{ badge }}</span>
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
export default {
  name: 'action-chip-v2026',
  props: {
    label: {
      type: String,
      default: ''
    },
    // CSS-mask url, not an <img> src — the glyph takes its colour from the chip.
    icon: {
      type: String,
      default: () => require('@/assets/icons2026/tag.svg')
    },
    op: {
      type: Boolean,
      default: false
    },
    badge: {
      type: String,
      default: ''
    },
    // Overrides the outline; the icon follows automatically via currentColor. '' keeps the default.
    color: {
      type: String,
      default: ''
    },
    // Opt-in solid chip: { bg, fg, border } from tagChipFill.js. Wins over `color`; null (or a
    // partial object) keeps the outline above, byte-for-byte. The inline background beats the
    // scoped white, so no CSS here changes.
    fill: {
      type: Object,
      default: null
    }
  },
  computed: {
    validFill () {
      const fill = this.fill
      return !!(fill && typeof fill === 'object' && fill.bg && fill.fg && fill.border)
    }
  }
}
</script>

<style scoped>
.v2026-action-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--v2026-color-main);
  border: 1px solid var(--v2026-color-main);
  border-radius: 14px;
  padding: 5px 12px;
  background: #ffffff;
}

.v2026-action-chip-ico {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: -0.125em;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: currentColor;
}

.v2026-action-chip--op {
  color: #fa5252;
  background: #ffffff;
  border-color: #fa5252;
}

.v2026-op-badge {
  font-weight: 700;
  color: #ffffff;
  background: #fa5252;
  border-radius: 4px;
  padding: 0 4px;
  font-size: 10px;
}
</style>
